import listThreadEventsPage from '@/redux/requests/threads/listThreadEventsPage.js';

/** Loads the events of one automation run's conversation (its steps and its final answer) into the run history. */
const getAutomationRunEvents = ({ threadId } = {}) => {
  return listThreadEventsPage({ threadId, limit: 200, action: 'GET_AUTOMATION_RUN_EVENTS', loader: 'getAutomationRunEvents' });
};

export default getAutomationRunEvents;
